import { render, staticRenderFns } from "./RecoveryPasswordForm.vue?vue&type=template&id=e868ac26&"
import script from "./RecoveryPasswordForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputText: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/inputs/InputText.vue').default})
